import { DateTime } from "luxon";

import { UserMeeting, ApiSessionsListEntity } from "@app/common/types";

import { StandingsMetricDataWithScores } from "../MeetingReport/types";
import { STANDINGS_METRICS_ITEM } from "../MeetingReport/utils/getStandingsMetrics";

const SAMPLE_REPORT_TITLE = "Sample - Meeting Report";

export const PROD_API_SAMPLE_MEETING: ApiSessionsListEntity = {
  id: "01GZCHRK1F9T0ZPX1TTNVBR2M3",
  title: SAMPLE_REPORT_TITLE,
  alerts: [],
  calendarEvent: null,
  isBillingUpgraded: false,
  isUpsellPreview: false,
  meetingPlatform: "zoom",
  metrics: {
    engagement: 88,
    hasConferenceRoom: false,
    meetingScore: 87,
    observedDuration: 840,
    observedParticipantCount: 5,
    observedStartTime: "2023-05-01T21:01:00.986395Z",
    participantLateBy: null,
    participantMissedMeetings: null,
    recurringEventId: "",
    scheduledDuration: null,
    scheduledStartTime: null,
    sentiment: 85,
    talkTimeRatio: null,
    topics: [
      "meetings",
      "real time",
      "moment",
      "summaries",
      "metrics",
      "organization",
    ],
  },
  metricsLevel: "full",
  ownerUserName: "Read AI",
  ownerUserId: "0",
  permissions: [],
  recordingEnabled: true,
  meetingId: "",
  message: "",
  optOut: false,
  startTime: "2023-05-01T21:01:00.986395Z",
  endTime: "2023-05-01T21:15:00.986395Z",
  state: "ended",
  tags: [],
  thumbnailUrl: null,
  transcriptionEnabled: true,
};

export const STAGING_API_SAMPLE_MEETING: ApiSessionsListEntity = {
  ...PROD_API_SAMPLE_MEETING,
  id: "01HF57GDP8HKVFWJGYKW05JJTR",
};

export const PROD_SAMPLE_MEETING: UserMeeting = {
  id: "01GZCHRK1F9T0ZPX1TTNVBR2M3",
  title: SAMPLE_REPORT_TITLE,
  startTime: DateTime.fromISO("2023-05-01T21:01:00.986395Z"),
  endTime: DateTime.fromISO("2023-05-01T21:15:00.986395Z"),
  meetingScore: 87,
  engagement: 88,
  sentiment: 85,
  lateBy: 0,
  numParticipants: 5,
  hasConferenceRoom: false,
  isUpsellPreview: false,
  keywords: [
    "meetings",
    "real time",
    "moment",
    "summaries",
    "metrics",
    "organization",
  ],
  ownerName: "Read AI",
  meetingPlatform: "zoom",
  alerts: [],
  state: "ended",
  permissions: [],
};

export const STAGING_SAMPLE_MEETING: UserMeeting = {
  ...PROD_SAMPLE_MEETING,
  id: "01HF57GDP8HKVFWJGYKW05JJTR",
};

export const SAMPLE_MEETING_IDS = [
  PROD_SAMPLE_MEETING.id,
  STAGING_SAMPLE_MEETING.id,
];

export const SAMPLE_METRICS: {
  [index: string]: {
    title: string;
    metrics: StandingsMetricDataWithScores[];
  };
} = {
  // staging
  "01HF57GDP8HKVFWJGYKW05JJTR": {
    title: SAMPLE_REPORT_TITLE,
    metrics: [
      { ...STANDINGS_METRICS_ITEM.microphoneOff, score: 25, average: 30 },
      { ...STANDINGS_METRICS_ITEM.cameraOff, score: 10, average: 12 },
      { ...STANDINGS_METRICS_ITEM.participantScore, score: 75, average: 77 },
      { ...STANDINGS_METRICS_ITEM.sentiment, score: 72, average: 76 },
      { ...STANDINGS_METRICS_ITEM.engagement, score: 88, average: 81 },
      { ...STANDINGS_METRICS_ITEM.charisma, score: null, average: 77 },
      { ...STANDINGS_METRICS_ITEM.bias, score: 76, average: null },
    ],
  },
  // prod
  "01GZCHRK1F9T0ZPX1TTNVBR2M3": {
    title: SAMPLE_REPORT_TITLE,
    metrics: [
      { ...STANDINGS_METRICS_ITEM.microphoneOff, score: 10, average: 7 },
      { ...STANDINGS_METRICS_ITEM.cameraOff, score: 2, average: 3 },
      { ...STANDINGS_METRICS_ITEM.participantScore, score: 89, average: 82 },
      { ...STANDINGS_METRICS_ITEM.sentiment, score: 82, average: 77 },
      { ...STANDINGS_METRICS_ITEM.engagement, score: 96, average: 87 },
      { ...STANDINGS_METRICS_ITEM.charisma, score: null, average: 75 },
      { ...STANDINGS_METRICS_ITEM.bias, score: 80, average: null },
    ],
  },
};
